/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_ProductInputs */

const en_edit_product = /** @type {(inputs: Edit_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Product`)
};

const es_edit_product = /** @type {(inputs: Edit_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar producto`)
};

/**
* | output |
* | --- |
* | "Edit Product" |
*
* @param {Edit_ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_product = /** @type {((inputs?: Edit_ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_product(inputs)
	return es_edit_product(inputs)
});